import { createFileRoute } from '@tanstack/react-router'
import { SavedQueryProvider } from '~/features/saved-query'
import { useTitle } from '~/hooks'

import { ExploreCurrentView } from './-components/current-view'

export const Route = createFileRoute('/_authenticated/$alias/_app/explore/')({
  component: RouteComponent,
})

function RouteComponent() {
  Route.useSearch()
  useTitle('Explore Interactions')

  return (
    <SavedQueryProvider type="explore" from="/$alias/explore/">
      <div className="flex grow flex-col">
        <ExploreCurrentView />
      </div>
    </SavedQueryProvider>
  )
}
